import React from 'react';
export function FooterSection() {
  return <footer className="w-full px-6 py-8 border-t border-warm-cream/10" data-id="element-82">
      <div className="max-w-3xl mx-auto text-center space-y-4" data-id="element-83">
        <p className="text-warm-cream/60 text-sm" data-id="element-84">
          NEURO RESET Somático es un producto de bienestar, no un tratamiento
          médico. Las técnicas y herramientas proporcionadas son complementarias
          y no sustituyen el consejo, diagnóstico o tratamiento médico
          profesional.
        </p>
        <p className="text-warm-cream/40 text-sm" data-id="element-85">
          © 2026 NEURO RESET Somático. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}